import React from "react";

import { CountrySelect } from "src/common/components/CountrySelect";
import { IsLockedContext } from "src/features/forms/context/IsLockedContext";
import { useValue } from "src/features/forms/hooks/useField";
import { CommonProps } from "src/features/forms/types";

export const CountrySelectRenderer: React.FunctionComponent<
	CommonProps
> = directProps => {
	const isLocked = React.useContext(IsLockedContext);
	const [value, onChangeValue] = useValue<string | undefined>(undefined);
	return (
		<CountrySelect
			{...directProps}
			disabled={isLocked}
			value={value}
			onChangeValue={onChangeValue}
		/>
	);
};
